module.exports = __webpack_public_path__ + "static/media/tangible-resource.a2728901.svg";